
import React, { useState, useRef, useEffect } from 'react';
import './Est.css';
import { Button, Datepick, Flex, Flexed, Input, Label } from '../../Shared';
import axios from 'axios';
import BookEstimate, { BookEstimateProvider } from '../../Context/BookEstimate';
import PocketFolder2 from '../quotes/PocketFolder2'
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AddQuantities from './AddQuantities';
import Select from 'react-select';
import Necc from '../Necc';
import Books from './Books';

function Estimate() {
    const initialstate = {
        pocketfolder: [],
        diecutting: [],
        books: [],
        necc: []
    };

    const [estitems, setEstitems] = useState(initialstate);
    const [customers, setCustomers] = useState([]);
    const [quoteinfo, setQuoteinfo] = useState({});
    const [selectedCustomer, setSelectedCustomer] = useState({});
    const [billto, setBillto] = useState({});
    const [shipto, setShipto] = useState({});
    const [todayDate, setTodayDate] = useState(new Date());
    const [dueDate, setDueDate] = useState(null);
    const [quotenum, setQuotenum] = useState(null);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMiniOpen, setIsMiniOpen] = useState(false);
    const [isBookOpen, setIsBookOpen] = useState(false);
    const [editingItem, setEditingItem] = useState(null);

    const nav = useNavigate();
    const param = useParams();

    // Load customers
    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const res = await axios.get('https://cfpapi-6ab062006fa0.herokuapp.com/customers/getall');
                const opts = res.data.map(cust => ({
                    value: cust._id,
                    label: cust.name,
                    customer: cust
                }));
                setCustomerOptions(opts);
                setCustomers(res.data); // Keep full list for lookup
            } catch (err) {
                toast.error("Could not load customers");
            }
        };
        fetchCustomers();
    }, []);

    // Load existing quote
    useEffect(() => {
        if (!param.id) return;

        const loadQuote = async () => {
            try {
                const res = await axios.post('https://cfpapi-6ab062006fa0.herokuapp.com/quotes/getquote', { id: param.id });
                const q = Array.isArray(res.data) ? res.data[0] : res.data;

                setTodayDate(new Date(q.quoteDate || Date.now()));
                setDueDate(q.dueDate ? new Date(q.dueDate) : null);
                setQuotenum(q.quotenum);

                setQuoteinfo({
                    jobname: q.jobName || "Untitled Job",
                    custjobnum: q.customerJobNumber || "",
                    custponum: q.customerPO || ""
                });

                setBillto(q.billTo || {});
                setShipto(q.shipTo || {});

                setEstitems({
                    pocketfolder: q.items?.pocketfolder || [],
                    diecutting: q.items?.diecutting || [],
                    books: q.items?.books || [],
                    necc: q.items?.necc || []
                });

                // FIXED: Properly restore selected customer (this was the bug!)
                if (q.customer && customerOptions.length > 0) {
                    const customerId = typeof q.customer === 'string' ? q.customer : q.customer._id;
                    const matchedOption = customerOptions.find(opt => opt.value === customerId);
                    if (matchedOption) {
                        setSelectedCustomer(matchedOption.customer);
                        const addr = matchedOption.customer.address?.[0] || {};
                        setBillto({ address1: addr.address1 || '', city: addr.city || '', state: addr.state || '', zip: addr.zip || '' });
                        setShipto({ ...addr });
                    }
                }
            } catch (err) {
                toast.error("Quote not found");
                nav('/estimate');
            }
        };
        loadQuote();
    }, [param.id, customerOptions]); // ← Now depends on customerOptions too!


    console.log(selectedCustomer)
    // FINAL SAVE + UPDATE
    const handleSaveQuote = async () => {
        const hasItems = estitems.pocketfolder.length > 0 ||
                         estitems.diecutting.length > 0 ||
                         estitems.books.length > 0 ||
                         estitems.necc?.length > 0;


        const quoteData = {
            id: param.id,
            quoteNumber: quotenum || `Q-${Date.now()}`,
            date: todayDate.toISOString(),
            dueDate: dueDate ? dueDate.toISOString() : null,
            customer: selectedCustomer|| null,
            jobName: quoteinfo?.jobname || "Untitled Quote",
            customerJobNumber: quoteinfo?.custjobnum || "",
            customerPO: quoteinfo?.custponum || "",
            billTo: billto,
            shipTo: shipto,
            items: {
                pocketfolder: estitems.pocketfolder,
                diecutting: estitems.diecutting,
                books: estitems.books,
                necc: estitems.necc || []
            },
            grandTotal: [
                ...estitems.pocketfolder,
                ...estitems.diecutting,
                ...estitems.books,
                ...(estitems.necc || [])
            ].reduce((sum, item) => sum + parseFloat(item.grandTotal || 0), 0).toFixed(2),
            updatedAt: new Date()
        };

        try {
            let response;
            if (param.id) {
                response = await axios.post(`https://cfpapi-6ab062006fa0.herokuapp.com/quotes/updatequote`, quoteData);
                toast.success(`Quote ${quotenum} updated!`);
            } else {
               response = await axios.post('https://cfpapi-6ab062006fa0.herokuapp.com/quotes/addquote', quoteData);
               //response = await axios.post('http://localhost:5009/quotes/addquote', quoteData);
                toast.success("Quote saved!");
                setQuotenum(response.data.quoteNumber || response.data.quotenum);
                nav(`/estimate/${response.data._id || response.data.id}`);
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to save quote");
        }
    };

    // AUTO-SAVE
// AUTO-SAVE - FIXED VERSION
useEffect(() => {
    if (!param.id) return;

    const hasItems = estitems.pocketfolder.length > 0 ||
                     estitems.diecutting.length > 0 ||
                     estitems.books.length > 0 ||
                     estitems.necc?.length > 0;

    if (!hasItems) return;

    // NEW: Prevent autosave if customer not loaded yet when editing existing quote
    if (!selectedCustomer?._id) {
        console.log("Skipping autosave - customer not loaded yet");
        return;
    }

    const timeoutId = setTimeout(() => {
        console.log("Auto-saving...");
        handleSaveQuote();
    }, 1000); // slightly longer debounce feels better too

    return () => clearTimeout(timeoutId);
}, [JSON.stringify(estitems), selectedCustomer?._id, param.id]);

    const openModal = (item = null) => { setEditingItem(item); setIsModalOpen(true); };
    const openMini = (item = null) => { setEditingItem(item); setIsMiniOpen(true); };
    const openBook = (item = null) => { setEditingItem(item); setIsBookOpen(true); };
    const closeModal = () => { setIsModalOpen(false); setEditingItem(null); };
    const closeMini = () => { setIsMiniOpen(false); setEditingItem(null); };
    const closeBook = () => { setIsBookOpen(false); setEditingItem(null); };

    const hasAnyItems = estitems.pocketfolder.length > 0 ||
                        estitems.diecutting.length > 0 ||
                        estitems.books.length > 0 ||
                        estitems.necc?.length > 0;

    return (
        <BookEstimateProvider>
            {/* Header */}
            <Flexed>
                <Flex fontSize="calc(1.3rem + .2vw)">Estimator</Flex>
                <Flex textAlign="right" paddingRight="20px" fontWeight="bold">
                    {quotenum && `Quote# ${quotenum}`}
                </Flex>
            </Flexed>

            {/* Customer & Dates */}
            <Flexed>
                <Flex flex="2">
                    <Label>Customer</Label><br />
                    <Select
                        options={customerOptions}
                        value={customerOptions.find(o => o.value === selectedCustomer?._id) || null}
                        onChange={(opt) => {
                            if (!opt) { setSelectedCustomer({}); setBillto({}); setShipto({}); return; }
                            const cust = opt.customer;
                            setSelectedCustomer(cust);
                            const addr = cust.address?.[0] || {};
                            setBillto({ address1: addr.address1 || '', city: addr.city || '', state: addr.state || '', zip: addr.zip || '' });
                            setShipto({ ...addr });
                        }}
                        placeholder="Search customer..."
                        isClearable
                    />
                </Flex>
                <Flex flex=".5"><Label>Today</Label><br /><Datepick selected={todayDate} onChange={setTodayDate} /></Flex>
                <Flex flex=".5"><Label>Due Date</Label><br /><Datepick selected={dueDate} onChange={setDueDate} /></Flex>
            </Flexed>

            {/* Job Info */}
            <Flexed>
                <Flex><Label>Job Name</Label><br /><Input value={quoteinfo?.jobname || ''} onChange={e => setQuoteinfo(p => ({...p, jobname: e.target.value}))} /></Flex>
                <Flex><Label>Cust Job #</Label><br /><Input value={quoteinfo?.custjobnum || ''} onChange={e => setQuoteinfo(p => ({...p, custjobnum: e.target.value}))} /></Flex>
                <Flex><Label>Cust P.O.</Label><br /><Input value={quoteinfo?.custponum || ''} onChange={e => setQuoteinfo(p => ({...p, custponum: e.target.value}))} /></Flex>
            </Flexed>

            {/* Add Buttons */}
            <div className="grid grid-cols-3" style={{ margin: '20px 0' }}>
                <div style={{ padding: '10px' }}>
                    <Button onClick={() => openModal()} style={{ background: '#0E425A', color: 'white' }}>Standard Pocket Folder</Button>
                    {/* {isModalOpen && <AddQuantities closeModal={closeModal} setEstitems={setEstitems} estitems={estitems} editingItem={editingItem} />} */}
                         {isModalOpen && <PocketFolder2 closeModal={closeModal} setEstitems={setEstitems} estitems={estitems} editingItem={editingItem} />}
                </div>
                <div style={{ padding: '10px' }}>
                    <Button onClick={() => openBook()} style={{ background: '#0E425A', color: 'white' }}>Books</Button>
                    {isBookOpen && <Books closeBook={closeBook} setEstitems={setEstitems} estitems={estitems} editingItem={editingItem} />}
                </div>
                <div style={{ padding: '10px' }}>
                    <Button onClick={() => openMini()} style={{ background: '#0E425A', color: 'white' }}>Mini</Button>
                    {isMiniOpen && <Necc closeMini={closeMini} setEstitems={setEstitems} estitems={estitems} editingItem={editingItem} />}
                </div>
            </div>

            {/* QUOTE ITEMS SUMMARY */}
            {!hasAnyItems ? (
                <div style={{ textAlign: 'center', color: '#888', fontSize: '1.4rem', margin: '40px 0' }}>
                    No Current Quote Items
                </div>
            ) : (
                <div style={{ marginTop: '20px' }}>
                    <h2 style={{ color: '#1976d2', borderBottom: '3px solid #4EC0AC', paddingBottom: '10px' }}>
                        Quote Items Summary
                    </h2>

                    {/* POCKET FOLDERS */}
                    {estitems.pocketfolder.map((pf, i) => (
                        <div key={pf.id || i} style={{
                            border: '1px solid #ddd', borderRadius: '12px', padding: '20px', margin: '20px 0',
                            backgroundColor: '#f8fdff', boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                                <h3 style={{ margin: 0, color: '#1976d2', fontSize: '1.5rem' }}>
                                    Pocket Folder #{i + 1} — {pf.width}" × {pf.length}" — {pf.pockets} Pocket{pf.pockets > 1 ? 's' : ''}
                                    <button onClick={() => openModal(pf)} style={{
                                        marginLeft: '20px', padding: '6px 20px', border: '1px solid #1976d2',
                                        background: 'none', color: '#1976d2', borderRadius: '6px', fontWeight: 'bold', fontSize: '0.9rem'
                                    }}>Edit</button>
                                </h3>
                                <button onClick={() => setEstitems(p => ({
                                    ...p, pocketfolder: p.pocketfolder.filter((_, idx) => idx !== i)
                                }))} style={{
                                    background: '#e53935', color: 'white', border: 'none', padding: '10px 20px',
                                    borderRadius: '6px', fontWeight: 'bold'
                                }}>Remove</button>
                            </div>

                            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                                <thead><tr style={{ backgroundColor: '#e3f2fd' }}>
                                    <th style={{ padding: '12px', textAlign: 'left' }}>Quantity</th>
                                       <th style={{ padding: '12px', textAlign: 'left' }}>Pieces</th>
                                    <th style={{ padding: '12px', textAlign: 'right' }}>Price/Unit</th>
                                    <th style={{ padding: '12px', textAlign: 'right' }}>Line Total</th>
                                </tr></thead>
                                <tbody>
                                    {pf.quantities.map((q, qi) => (
                                        <tr key={qi}>
                                            <td style={{ padding: '12px', fontWeight: 'bold' }}>{q.quantity.toLocaleString()}</td>
                                            <td style={{ padding: '12px', textAlign: 'right' }}>${Number(q.pricePerUnit).toFixed(4)}</td>
                                               <td style={{ padding: '12px', textAlign: 'right' }}>${Number(q.numUp)}</td>
                                            <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold', color: '#2e7d32' }}>
                                                ${Number(q.totalPrice).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ))}

                    {/* NECC / FINISHING */}
                    {estitems.necc?.map((item, i) => (
                        <div key={item.id || i} style={{ border: '1px solid #ddd', borderRadius: '12px', padding: '20px', margin: '20px 0', backgroundColor: '#f8fdff' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h3 className="text-xl font-bold text-blue-700 mb-2">
                                    Finishing #{i + 1} — {item.width}" × {item.length}" on {item.press}
                                    {item.dieCut && " + Diecut"}
                                    {item.perf && " + Perf"}
                                    {item.score && " + Score"}
                
                                </h3>
                                <div>
                                    <button onClick={() => openMini(item)} style={{ marginRight: '10px', padding: '6px 16px', border: '1px solid #1976d2', background: 'none', color: '#1976d2' }}>Edit</button>
                                    <button onClick={() => setEstitems(p => ({ ...p, necc: p.necc.filter((_, idx) => idx !== i) }))} style={{ background: '#e53935', color: 'white', border: 'none', padding: '6px 16px' }}>Remove</button>
                                </div>
                            </div>

                            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
                                <thead><tr style={{ backgroundColor: '#e3f2fd' }}>
                                    <th style={{ padding: '12px', textAlign: 'left' }}>Quantity</th>
                                       <th style={{ padding: '12px', textAlign: 'left' }}>Pieces</th>

                                    <th style={{ padding: '12px', textAlign: 'right' }}>Price/Unit</th>
                                    <th style={{ padding: '12px', textAlign: 'right' }}>Line Total</th>
                                </tr></thead>
                                <tbody>
                                    {item.quantities.map((q, qi) => (
                                        <tr key={qi}>
                                            <td style={{ padding: '12px', fontWeight: 'bold' }}>{q.quantity.toLocaleString()}</td>
                                              <td style={{ padding: '12px', textAlign: 'left' }}>{(parseInt(q.quantity) * parseInt(item.numUp) )}</td>
                                            <td style={{ padding: '12px', textAlign: 'right' }}>${Number(q.pricePerUnit).toFixed(4)}</td>
                                            <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold', color: '#2e7d32' }}>${Number(q.totalPrice).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {(item.emboss || item.deboss || item.foil) && (
                                <div style={{ marginTop: '15px', padding: '15px', backgroundColor: '#fff8e1', borderRadius: '8px', border: '1px solid #ffb300' }}>
                                    <strong>Addons:</strong>
                                    {item.emboss && ` Embossing (${item.emboss.plates.length} plate${item.emboss.plates.length > 1 ? 's' : ''})`}
                                    {item.deboss && ` Debossing (${item.deboss.plates.length} plate${item.deboss.plates.length > 1 ? 's' : ''})`}
                                    {item.foil && ` Foil (${item.foil.plates.length} color${item.foil.plates.length > 1 ? 's' : ''})`}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* SAVE BUTTON */}
            <Flex textAlign="right" marginTop="40px">
                <Button
                    onClick={handleSaveQuote}
                   
                    style={{
                        padding: '16px 50px', fontSize: '1.3rem',
                        backgroundColor: hasAnyItems ? '#4EC0AC' : '#aaa',
                        color: 'white', fontWeight: 'bold',
                       
                    }}
                >
                    {param.id ? 'Update Quote' : 'Save New Quote'}
                </Button>
            </Flex>
            <br /><br /><br />
        </BookEstimateProvider>
    );
}

export default Estimate;


